var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMuscle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3334 16.3199C26.0373 16.1994 24.7344 16.4609 23.5853 17.0722C22.4361 17.6835 21.4911 18.6178 20.8667 19.7599",
    stroke: "#08A693",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6534 17.4267C20.9762 16.8657 20.1878 16.4546 19.3403 16.2204C18.4927 15.9861 17.6052 15.934 16.736 16.0676C15.8669 16.2011 15.0359 16.5172 14.2977 16.995C13.5596 17.4729 12.931 18.1017 12.4534 18.84",
    stroke: "#08A693",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7333 22.4934C14.5624 22.9406 15.4985 23.151 16.4392 23.1016C17.3799 23.0522 18.2889 22.7449 19.0666 22.2134",
    stroke: "#08A693",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5734 18.6667C13.8491 17.3917 14.5967 15.6823 14.6667 13.88C14.7534 12.1954 15.0719 10.5309 15.6134 8.93335",
    stroke: "#08A693",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7733 25.0667C22.7733 25.0667 14.6666 32.2133 5.33328 23.08C5.00062 22.7099 4.77419 22.2568 4.67796 21.7686C4.58173 21.2804 4.61927 20.7753 4.78661 20.3067C6.11995 16.9333 7.45328 10.7867 12.9733 5.37333L16.7466 2.81333C16.9985 2.62825 17.3074 2.53754 17.6193 2.55704C17.9312 2.57654 18.2264 2.705 18.4533 2.91999L21.1199 5.41333C21.2469 5.5375 21.3478 5.6858 21.4167 5.84951C21.4856 6.01322 21.5211 6.18904 21.5211 6.36666C21.5211 6.54427 21.4856 6.7201 21.4167 6.88381C21.3478 7.04752 21.2469 7.19582 21.1199 7.31999C20.0133 8.45333 17.9866 9.71999 15.9999 6.67999",
    stroke: "#08A693",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3334 26.0532C21.3334 26.0532 22.5334 26.3332 23.32 29.4532",
    stroke: "#08A693",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuscle);
export default __webpack_public_path__ + "static/media/muscle.fbae5b3ecd192f87bca59d59a5eeefe3.svg";
export { ForwardRef as ReactComponent };